/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Chain_To_Previous_EventInputs */

const en_shortcut_keys_name_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chain To Previous Event`)
};

const fr_shortcut_keys_name_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chainer a l'evenement precedent`)
};

const de_shortcut_keys_name_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung zum vorherigen Ereignis herstellen`)
};

const it_shortcut_keys_name_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concatena all'evento precedente`)
};

const ru_shortcut_keys_name_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цепочка к предыдущему событию`)
};

const es_shortcut_keys_name_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadena al evento anterior`)
};

const zh_cn2_shortcut_keys_name_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链至上一个事件`)
};

const ja_shortcut_keys_name_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のイベントへのチェーン`)
};

const hi_shortcut_keys_name_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछली घटना से जुड़ाव`)
};

const pt_pt2_shortcut_keys_name_chain_to_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encadeamento ao evento anterior`)
};

/**
* | output |
* | --- |
* | "Chain To Previous Event" |
*
* @param {Shortcut_Keys_Name_Chain_To_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_chain_to_previous_event = /** @type {((inputs?: Shortcut_Keys_Name_Chain_To_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Chain_To_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_chain_to_previous_event(inputs)
	if (locale === "de") return de_shortcut_keys_name_chain_to_previous_event(inputs)
	if (locale === "it") return it_shortcut_keys_name_chain_to_previous_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_chain_to_previous_event(inputs)
	if (locale === "es") return es_shortcut_keys_name_chain_to_previous_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_chain_to_previous_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_chain_to_previous_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_chain_to_previous_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_chain_to_previous_event(inputs)
	return en_shortcut_keys_name_chain_to_previous_event(inputs)
});